<template>
  <div>
    <div
      data-id="macros-section"
      v-if="!uiFlags.isFetching && !macros.length"
      class="macros_list--empty-state"
    >
      <p class="flex h-full items-center flex-col justify-center">
        {{ $t('MACROS.LIST.404') }}
      </p>
      <router-link :to="addAccountScoping('settings/macros')">
        <woot-button
          variant="smooth"
          icon="add"
          size="tiny"
          class="macros_add-button"
        >
          {{ $t('MACROS.HEADER_BTN_TXT') }}
        </woot-button>
      </router-link>
    </div>
    <woot-loading-state class="macros-loading-state"
      v-if="uiFlags.isFetching"
      :message="$t('MACROS.LOADING')"
    />
    <div v-if="!uiFlags.isFetching && macros.length" class="macros-list">
      <macro-item
        v-for="macro in macros"
        :key="macro.id"
        :macro="macro"
        :conversation-id="conversationId"
        @use-response="handleUseResponse"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import MacroItem from './MacroItem';
import accountMixin from 'dashboard/mixins/account.js';

export default {
  components: {
    MacroItem,
  },
  mixins: [accountMixin],
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
    filterType: {
      type: String,
      default: null,
      validator: value => value === null || value === 'ai_agents' || value === 'normal_api_call',
    },
  },
  computed: {
    ...mapGetters({
      allMacros: ['macros/getMacros'],
      uiFlags: 'macros/getUIFlags',
    }),
    macros() {
      // If filterType is 'ai_agents', show only macros with API webhook
      if (this.filterType === 'ai_agents') {
        return this.allMacros.filter(macro => {
          return macro.actions?.some(
            action => action.action_name === 'send_api_webhook'
          );
        });
      }
      
      // Otherwise show all macros except those with API webhooks
      return this.allMacros.filter(macro => {
        return !macro.actions?.some(
          action => action.action_name === 'send_api_webhook'
        );
      });
    },
  },
  mounted() {
    this.$store.dispatch('macros/get');
  },
  methods: {
    handleUseResponse(messageBody) {
      this.$emit('use-response', messageBody);
    },
  },
};
</script>
<style scoped lang="scss">
.macros-list {
  padding: var(--space-smaller);
}
.dark .macros-list {
  background-color: #121212;
}
.macros_list--empty-state {
  padding: var(--space-slab);
  p {
    margin: 0;
  }
}
.dark .macros_list--empty-state {
  background-color: #121212;
}
.macros_add-button {
  margin: var(--space-small) auto 0;
}
.dark .macros-loading-state{
  background-color: #121212;
}
</style>
